import { CONFIG } from './config.js';
import {
  preco, faixaQuartos, faixaArea, entrega,
  rotuloConstrutora, rotuloDiferencial, comoLista,
} from './formato.js';

export const escapa = (s) =>
  String(s ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

/**
 * O número já vem em formato internacional completo em CONFIG.whatsapp.
 * Não concatenar 55 aqui: geraria wa.me/5555...
 */
export function linkWhatsapp(p) {
  const onde = [p.bairro, p.cidade].filter(Boolean).join(', ');
  const texto =
    `Olá! Vi o ${p.titulo}${onde ? ` (${onde})` : ''} no mapa do MeMude ` +
    'e quero saber mais.';
  return `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(texto)}`;
}

const item = (rotulo, valor) =>
  (valor
    ? `<div class="ficha-item"><span>${escapa(rotulo)}</span><strong>${escapa(valor)}</strong></div>`
    : '');

export function montaHtmlCartao(p) {
  const dif = comoLista(p.diferenciaisTop)
    .map((d) => `<li>${escapa(rotuloDiferencial(d))}</li>`)
    .join('');

  const foto = p.fotoCapa
    ? `<img class="cartao-foto" src="${escapa(p.fotoCapa)}" loading="lazy" decoding="async"
            alt="Foto do empreendimento ${escapa(p.titulo)}">`
    : '';

  const aviso = p.precisao === 'bairro'
    ? '<p class="cartao-aviso">Localização aproximada — posição do bairro</p>'
    : '';

  const selo = p.status ? `<span class="cartao-selo">${escapa(p.status)}</span>` : '';

  return `
  ${foto}
  <div class="cartao-corpo">
    ${selo}
    <h3 class="cartao-titulo">${escapa(p.titulo)}</h3>
    <p class="cartao-local">${escapa([p.bairro, p.cidade].filter(Boolean).join(' · '))}</p>
    <p class="cartao-preco">${escapa(preco(p.precoMin))}<small>a partir de</small></p>
    <div class="cartao-ficha">
      ${item('Quartos', faixaQuartos(p.quartosMin, p.quartosMax))}
      ${item('Área', faixaArea(p.areaMin, p.areaMax))}
      ${item('Entrega', entrega(p.entrega))}
      ${item('Construtora', rotuloConstrutora(p.construtora))}
    </div>
    ${dif ? `<ul class="cartao-dif">${dif}</ul>` : ''}
    ${aviso}
    <div class="cartao-acoes">
      <a class="botao primario" href="${escapa(linkWhatsapp(p))}"
         target="_blank" rel="noopener" data-evento="whatsapp_clique" data-id="${escapa(p.id)}">
        Falar no WhatsApp
      </a>
      <a class="botao secundario" href="${escapa(p.url)}"
         target="_blank" rel="noopener" data-evento="site_clique" data-id="${escapa(p.id)}">
        Ver no site
      </a>
    </div>
  </div>`;
}

const ATRASO_MOSTRAR = 250;
const ATRASO_ESCONDER = 200;

export function criaCartao(elemento) {
  let timerMostrar = null;
  let timerEsconder = null;
  let idAtual = null;

  // Deixar o cartão de pé quando o cursor entra nele: sem isso não daria
  // para clicar nos botões, porque o cartão sumiria no caminho.
  elemento.addEventListener('mouseenter', () => clearTimeout(timerEsconder));
  elemento.addEventListener('mouseleave', () => esconde());

  // Começa a baixar a foto assim que o cursor encosta, sem esperar os 250 ms.
  // Quando o cartão abre, a imagem já está no cache.
  const precarregadas = new Set();
  function precarrega(url) {
    if (!url || precarregadas.has(url)) return;
    precarregadas.add(url);
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
  }

  function posiciona(ponto) {
    const largura = elemento.offsetWidth || 300;
    const altura = elemento.offsetHeight || 380;
    const margem = 12;
    let x = ponto.x + 16;
    let y = ponto.y - altura / 2;
    if (x + largura + margem > window.innerWidth) x = ponto.x - largura - 16;
    y = Math.max(margem, Math.min(y, window.innerHeight - altura - margem));
    elemento.style.left = `${x}px`;
    elemento.style.top = `${y}px`;
  }

  function mostra(props, ponto) {
    clearTimeout(timerEsconder);
    precarrega(props.fotoCapa);
    if (props.id === idAtual) { posiciona(ponto); return; }
    clearTimeout(timerMostrar);
    timerMostrar = setTimeout(() => {
      idAtual = props.id;
      elemento.innerHTML = montaHtmlCartao(props);
      elemento.hidden = false;
      posiciona(ponto);
    }, ATRASO_MOSTRAR);
  }

  function esconde() {
    clearTimeout(timerMostrar);
    timerEsconder = setTimeout(() => {
      elemento.hidden = true;
      idAtual = null;
    }, ATRASO_ESCONDER);
  }

  return { mostra, esconde };
}
